/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import store, { epicDependencies, storeObserver } from '../../store';
import { pluck } from '../../store.decorator';

export const useSelector = <TState>(
    path: string,
    fn: (state: TState) => void,
): Observable<TState> => {
    const ngZone = epicDependencies.injector.get<NgZone>(NgZone); // TODO revise
    // eslint-disable-next-line no-extra-parens
    return storeObserver<any, TState>(store, (state) =>
        pluck<TState>(state, path),
    ) // TODO revise store import
        .pipe(
            tap((state) => {
                if (ngZone) {
                    ngZone.run(() => fn(state));
                } else {
                    fn(state);
                }
            }),
        );
};
